import { AnyAction } from "redux";
import { createAction } from "redux-actions";
import { ThunkDispatch } from "redux-thunk";
import { isHasBasicInfo } from "../../../javascripts/generic";
import { RootState } from "../../reducers";
import { actionLogoutSuccess } from "../user";
import { DeviceService, DeviceState, DeviceType } from '../../../api/base/device/device'
import { post, url } from "../../../javascripts/http";
import { message } from "antd";

let deviceService = new DeviceService(url, post);

export function actionGetDeviceList (data) {
    return async(dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
        if(!isHasBasicInfo()) {
            dispatch(actionLogoutSuccess({}))
        }
        try {

            let orgId = getState().user.orgId;
            let res = await deviceService.pageListDevice({
                organizationId: +orgId,
                typeList: [DeviceType.FOOT_SCANNER],
                stateList: [DeviceState.OFFLINE, DeviceState.ONLINE],
                pageNum: data.pageNum - 1,
                pageSize: data.pageSize
            });
            let deviceList = res.deviceList || [];
            if(deviceList.length) {
                res.deviceList = deviceList.map((item) => {
                    
                    let orgId = item.inOrganizationId;
                    let logs = item.records.filter((s) => {
                        return s.fromOrganizationId === orgId || s.toOrganizationId === orgId ;
                    });
                    logs.sort((ma, mb) => {
                        let mat = +(ma.operatingTimestamp || '');
                        let mbt = +(mb.operatingTimestamp || '');
                        return mbt - mat;
                    });

                    let outTime = 0;
                    let inTime = 0;
                    logs.map((l) => {
                        if(l.fromOrganizationId === orgId && !outTime) {
                            outTime = +(l.operatingTimestamp || '');
                        }
                        if(l.toOrganizationId === orgId && !inTime) {
                            inTime = +(l.operatingTimestamp || '');
                        }
                    })
                    // item.records.sort((ma, mb) => {
                    //     if(ma.operatingTimestamp && mb.operatingTimestamp) {
                    //         return +(ma.operatingTimestamp) - +(mb.operatingTimestamp)
                    //     }
                    //     return 0;
                    // })
                    // let inTime = +(item.records[0].operatingTimestamp || 0);
                    // let outTime = 0;
                    // if(item.records.length > 1) {
                    //     outTime = +(item.records[1].operatingTimestamp || 0);
                    // }
                    Object.assign(
                        item, 
                        {
                            inTime,
                            outTime
                        }
                    )
                    return item;
                })
            }
           

            dispatch(actionGetDeviceListSuccess({
                data: res
            }))
        } catch (error) {

        }
    }
}

export const ACTION_GETDEVICELIST_SUCCESS = 'USER.ACTION_GETDEVICELIST_SUCCESS'

export interface ActionGetDeviceListPayload {
    data: any
}

export const actionGetDeviceListSuccess = createAction(
    ACTION_GETDEVICELIST_SUCCESS,
    (payload: ActionGetDeviceListPayload) => {
        return payload;
    }
)

export function actionGetDeviceDetail (data) {
    return async(dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
        if(!isHasBasicInfo()) {
            dispatch(actionLogoutSuccess({}))
        }
        message.loading('加载中...', 0)
        try {
            
            let res = await deviceService.getDevice(data);
            let orgId = res.device.inOrganizationId;
            let logs = res.device.records.filter((s) => {
                return s.fromOrganizationId === orgId || s.toOrganizationId === orgId ;
            });
            logs.sort((ma, mb) => {
                let mat = +(ma.operatingTimestamp || '');
                let mbt = +(mb.operatingTimestamp || '');
                return mbt - mat;
            });

            logs = logs.map((item) => {
                let status = ''
                if(item.fromOrganizationId === orgId) {
                    status = '出库';
                }
                if(item.toOrganizationId === orgId) {
                    status = '入库';
                }
                return {
                    ...item,
                    status,
                }
            })

            dispatch(actionGetDeviceDetailSuccess({
                data: {
                    ...res.device,
                    logs,
                }
            }))
            message.destroy();
        } catch (error) {
            message.error('加载失败, 请稍后重试', 6)
        }
        
    }
}

export const ACTION_GETDEVICEDETAIL_SUCCESS = 'USER.ACTION_GETDEVICEDETAIL_SUCCESS'

export interface ActionGetDeviceDetailPayload {
    data: any
}

export const actionGetDeviceDetailSuccess = createAction(
    ACTION_GETDEVICEDETAIL_SUCCESS,
    (payload: ActionGetDeviceDetailPayload) => {
        return payload
    }
)